import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { IEnumModel } from 'src/app/models/enum.model';
import { IListaQuestionarioRespostaUGModel, QuestionarioUGItensResposta } from 'src/app/models/questionario-ug.model';
import { QuestionarioUGService } from 'src/app/services/questionarioug.service';
import { BaseFormComponent } from 'src/app/shared/components/base-form/base-form.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { QuestionarioUGRespostaService } from 'src/app/services/questionarioug-resposta.service';
import { SharedService } from 'src/app/services/shared.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-imprimir-questionario',
  templateUrl: './imprimir-questionario.component.html',
  styleUrls: ['./imprimir-questionario.component.scss']
})
export class ImprimirQuestionarioComponent extends BaseFormComponent implements OnInit {
  public tiles = [];
  public idUnidadeGestora : number;
  public versao : number;
  public titulo: string='MATURIDADE DE RISCO';
  public dataFormatada : string; 
  public nomeUnidadeGestora : string;
  public dataSource = new MatTableDataSource<QuestionarioUGItensResposta>([]);
  displayedColumns: string[] = ['pergunta'];
  public model= {} as IListaQuestionarioRespostaUGModel;

  constructor(
    private questionarioUGService: QuestionarioUGService,
    toastr: ToastrService,
    route: ActivatedRoute,
    router: Router,
    localeService: BsLocaleService,
    public sharedService: SharedService,
    private questionarioService: QuestionarioUGRespostaService,
    public matDialog: MatDialog,
    public matGridListModule: MatGridListModule

  ) { 
    super(route, toastr, router, localeService, matDialog);
  }

  public form = new FormGroup({
    id: new FormControl({value: '', disabled:true}),
    nome: new FormControl('', Validators.required),
    tipoDocumento: new FormControl({value:[] as IEnumModel[]})
  })

  async ngOnInit() {
  
    if(!this.novoRegistro){
      this.questionarioService.ObterRespostaQuestionario(this.id)
      .then((res) => {
        this.model = res.dados;
        this.dataSource = new MatTableDataSource<QuestionarioUGItensResposta>(res.dados.respostas);
      });
    }
  
      if(!this.novoRegistro){
        this.questionarioUGService
        .ImprimirRespostaQuestionario(this.id)
        .then((res) => {
            if(res.sucesso){
                this.idUnidadeGestora = res.dados[0].idUnidadeGestora;
                this.dataFormatada = res.dados[0].dataFormatada;
                this.versao = res.dados[0].versao;
                this.nomeUnidadeGestora = res.dados[0].nomeUnidadeGestora;
            }else{
                this.exibirMensagemErro(res.mensagem.descricao);
            }
        })
         }   
  }

  print(): void {
    window.print();
  }
  public onBack() {
    this.submit = false;
    let aba = this.sharedService.getTipoQuestionario();
    this.router.navigateByUrl(`/unidades-gestoras/${this.idUnidadeGestora}?aba=${aba}`);
  }

}
